export default __webpack_public_path__ + "static/media/phone-verification-background-logged-in.db91a113.png";